<style lang="scss">

.parametric-table_row {
  padding-left: 15px;
}

.product-detail__checkbox-group {
  margin-top: 40px;
}
.parametric-search__results {
    position: relative;
}
.parametric-search__results-content {
  max-height: 486.8px;
}

.parametric-search__col-table .custom-checkbox-wrapper {
    position: relative;
}

.table__th-content--cursor {
    cursor: pointer;
}

.remove-on-desktop {
    display: none;
}

.product-detail__dropdown li {
    vertical-align: text-top;
}

.driver__link--cursor__pointer {
    cursor: pointer;
}

.parametric-filters-wrapper {
  max-height: 486.8px;
}

.parametric-filters-wrapper .filters-head {
  max-height: 73.5px;
  padding: 0 0 0 8px;
}

.parametric-filters-wrapper .filters-head h4 {
  font-size: 18px;
}

.parametric-filters-wrapper .filters-head span {
  min-height: 74.6px;
}

.parametric-search #parametric-search__table thead th {
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    text-transform: none;
}

.parametric-search .table__thead {
    border-top: 0 !important;
}

.parametric-search .table__tbody .table__row:first-child td {
    border-top: 0;
}

.parametric-close-button {
    content: '';
    border: 0;
    color: #FFF;
    background: #00A8E1;
    border-radius: 50%;
    width: 34px;
    height: 34px;
    position: absolute;
    right: 50px;
    bottom: 15px;
    display: none;
}

.parametric-close-button:focus {
    outline: none;
}

.parametric-search__col--collapsed .filters-head__filters-toggle .fa-close {
    transform: rotate(45deg);
}

/* Set the second last table cell to a wider width.
   It fixes a table misalignment because of the
   longer header name this column has */
.parametric-search .table__cell:nth-last-child(2),
.parametric-search .table__th:nth-last-child(2) {
    width: 120px;
    min-width: 120px;
}

.parametric-search .table__tbody .table__cell {
    -ms-word-break: break-word;
    word-break: break-word;
}

.filters-list__item-name {
  text-transform: none;
}

/*Mobile adjustments*/
@media only screen and (max-width: 767px) {
    #back-to-top {
        display: none !important;
    }

    .product-detail__dropdown {
        display: flex;
    }

    /* fixes sizing issue with buttons not going full width */
    .parametric-button-group {
        display: flex;
        flex-wrap: wrap;
        float: none !important;
    }

    .parametric-button-group .btn-toolbar {
        margin-top: 0 !important;
    }

    .product-detail__dropdown-menu--active {
        position: static;
    }

    .product-detail__dropdown-menu-col {
        width: 100% !important;
    }

    .product-detail__dropdown {
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding-top: 20px;
        margin: 0 15px;
    }

    .parametric-search__col {
        display: none;
    }

    .product-detail__dropdown .btn-default {
        margin-bottom: 5px !important;
    }

    .parametric-button-group {
        margin: 0 15px;
    }

    .button-compare {
        margin-left: 5px;
    }
    .filter-type-number {
        width: 100% !important;
        margin-bottom: 5px !important;
    }

    .parametric-search__col {
        height: 100vh;
        box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.2);
    }
    .parametric-search__col--collapsed {
        width: 270px;
    }

    .parametric-filters-wrapper {
        border: 0px;
    }

    .parametric-search__col--collapsed .filters-list {
        opacity: 1;
    }

    .parametric-search__col--collapsed .filters-head h4 {
        display: inline-block;
    }

    .parametric-search__col--collapsed .filters-head {
        padding: 8px 0 8px 8px;
    }

    .parametric-search__results {
        width: 100%;
    }
    .parametric-search__results {
        margin: 0 15px;
    }

    .filter-section-tablet {
        width: 100% !important;
    }

    .product-detail__dropdown .dropdown-toggle {
        order: 3;
        margin-bottom: 0 !important;
    }

    .product-detail__dropdown-menu--active {
        order: 4;
        margin: 0 5px 0 0 !important;
        padding: 6px 12px !important;
        border: 1px solid #00a8e1;
        border-top-width: 0;
    }

    .two-button-container {
        margin-left: 5px;
        width: 100%;
    }

    .two-button-flex {
        display: flex;
        width: 100%;
    }

    .two-button-flex > * {
        width: 50%;
    }

    .two-button-flex > *:last-child {
        margin-left: 5px;
    }

    .parametric-close-button {
        display: block;
    }
}


/*Tablet adjustements*/
@media (max-width: 992px) {
    .parametric-search__col--collapsible {
        display: none !important;
    }

    .btn-toolbar {
        margin-top: 40px !important;
    }

    .parametric-search__results {
        width: 100%;
    }

    .parametric-search__col {
        height: 100vh;
        box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.2);
    }
    .parametric-search__col--collapsed {
        width: 270px;
    }

    .parametric-filters-wrapper {
        border: 0px;
    }

    .parametric-search__col--collapsed .filters-list {
        opacity: 1;
    }

    .parametric-search__col--collapsed .filters-head h4 {
        display: inline-block;
    }

    .parametric-search__col--collapsed .filters-head {
        padding: 8px 0 8px 8px;
    }

    .desktop-only {
        visibility: hidden;
    }

    .remove-on-desktop {
        display: inherit;
    }

    .remove-on-tablet {
        display: none;
    }

    .compare-icon {
        margin: 12px 23px 12px 26px;
    }

    .parametric-search .table__element--fixed {
        position: relative !important;
    }

}

/* Apply this ONLY to tablets */
@media (min-width: 767px) and (max-width: 992px) {
    .filter-type-number {
        width: 345px !important;
    }

    .two-button-flex {
        display: flex;
    }

    .two-button-flex > * {
        margin-left: 5px;
    }
}

/* There should be no left margin in any platform/display */
.table__cell-meta-info {
    margin-left: 0 !important;
}

/*On click show first column, by adding this class for tablet and mobile*/
.show-col-collapsible {
    display: block !important;
    position: fixed !important;
    z-index: 99 !important;
    background: white;
    left: 0;
    top: 0;
}

.hide-col-collapsible {
    display: none;
}

#parametric-search__table {
    margin-top: 0 !important;
}

/*Hide button section on large devices*/
@media (min-width: 992px) {
    .btn-toolbar {
        display: none !important;
    }
}

#back-to-top {
    cursor: pointer;
    position: absolute;
    bottom: 30px;
    right: 30px;
    display: none;
}

.btn-circle {
    width: 34px;
    height: 34px;
    padding: 6px 0px;
    border-radius: 20px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
}

.product-detail__dropdown-menu-col {
    margin-top: 12px;
    vertical-align: top;
}

/* IE10+ specific fix */
@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    _:-ms-input-placeholder, :root .product-detail__dropdown-menu-col .product-detail__dropdown-menu__item {
        margin-right: 29px;
    }
    .button-icon {
        height: 18px;
    }

}

/* FIXME very ugly hack to center the icons on IE,
    otherwise display: flex seems not to be working on IE - MYA-138 */
.filters-head__filters-toggle i.fa-filter {
    margin: 20px 5px 20px 10px !important;
}

.filters-head__filters-toggle i.fa-close {
    margin: 20px 10px 20px 5px !important;
}

.custom-checkbox__checkmark {
    top: 10px !important;
    transform: translateY(-60%) !important;
}

.cls-1 {
    fill: none;
    opacity: 0.05;
}

.cls-2 {
    fill: #00a8e1;
}

.button-icon {
    width: 14px;
    vertical-align: middle;
}

.button-special:hover .cls-2 {
    fill: #ffffff;
}

.button-special:active .cls-2 {
    fill: #ffffff;
}

.button-special:focus .cls-2 {
    fill: #ffffff;
}

.btn-default:hover .cls-2 {
    fill: #ffffff;
}

.btn-default:active .cls-2 {
    fill: #ffffff;
}

.btn-default:focus .cls-2 {
    fill: #ffffff;
}

.parametric-filters-wrapper .demo-board__list.filters-list__nested-list {
    padding: 0;
}

.parametric-filters-wrapper .demo-board__main-item .demo-board__item-name {
    padding-bottom: 21px;

    &:not(.filters-list__item-name--active) {
        border-bottom: .5px solid #ddd;
        background-color: #eee;
    }
}
</style>

<template>
    <div v-if="isSuccess" class="row">
        <div class="row parametric-table_row first">
            <div class="col-xs-12">
                <ul class="product-detail__checkbox-group">
                    <li class="product-detail__dropdown">
                        <a v-if="this.productCategory || !this.isPublic"
                           class="btn btn-default product-detail__dropdown-anchor dropdown-toggle"
                           href="#" @click.prevent="showTargetApplications = !showTargetApplications"
                           role="button" aria-haspopup="true" aria-expanded="false">
                            Target Applications
                            <i class="fa fa-close" :class="{'dropdown-icon--active':showTargetApplications}"></i>
                        </a>
                        <a v-if="this.applicationCategory"
                           class="btn btn-default product-detail__dropdown-anchor dropdown-toggle"
                           href="#" @click.prevent="showTargetFrequencies = !showTargetFrequencies"
                           role="button" aria-haspopup="true" aria-expanded="false">
                            Target Frequencies
                            <i class="fa fa-close" :class="{'dropdown-icon--active':showTargetFrequencies}"></i>
                        </a>
                        <a class="btn btn-default product-detail__btn" href="#" role="button"
                           @click="redirectToPredefined('SUPPORT')">
                            Support
                        </a>
                        <a class="btn btn-default product-detail__btn" href="#" role="button"
                           @click="redirectToPredefined('SALES_INQUIRY')">
                            Sales inquiry
                        </a>
                        <div class="product-detail__dropdown-menu"
                             :class="{'product-detail__dropdown-menu--active':showTargetApplications}">
                            <ul>
                                <li v-for="(targetApplication, outerIndex) in targetApplications"
                                    class="product-detail__dropdown-menu-col">
                                    <ul>
                                        <li class="product-detail__dropdown-menu__item product-detail__dropdown-menu__item--bold">
                                                     <span class="custom-checkbox custom-checkbox-wrapper">
                                                        <input class="custom-checkbox__input" type="checkbox"
                                                               :id="targetApplication + outerIndex"
                                                               @change="checkSubCategories(targetApplication, $event)"
                                                               v-model="facetFilterValues"
                                                               :value="'targetApplication_' + targetApplication.jcrValue"/>
                                                        <span class="custom-checkbox__checkmark"></span>
                                                    </span>
                                            <label class="custom-control-label"
                                                   :for="targetApplication + outerIndex">{{targetApplication.displayName}}</label>
                                        </li>
                                        <li v-for="(targetApplicationFacet, innerIndex) in targetApplication.targetApplications"
                                            class="product-detail__dropdown-menu__item">

                                                <span class="custom-checkbox custom-checkbox-wrapper">
                                                        <input class="custom-checkbox__input" type="checkbox"
                                                               :id="targetApplicationFacet.displayName + outerIndex + innerIndex"
                                                               :value="'targetApplication_' + targetApplicationFacet.jcrValue"
                                                               v-model="facetFilterValues"
                                                               @change="fetchProductsWithModelFilters"/>
                                                        <span class="custom-checkbox__checkmark"></span>
                                                    </span>
                                            <label class="custom-control-label"
                                                   :for="targetApplicationFacet.displayName + outerIndex + innerIndex">{{targetApplicationFacet.displayName}}</label>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <button class="parametric-close-button" @click.prevent="showTargetApplications = false"><i
                                    class="fa fa-close"></i></button>
                        </div>
                        <div class="product-detail__dropdown-menu"
                             :class="{'product-detail__dropdown-menu--active':showTargetFrequencies}">
                            <ul>
                                <li v-for="(targetFrequency, outerIndex) in targetFrequencies"
                                    class="product-detail__dropdown-menu-col">
                                    <ul>
                                        <li class="product-detail__dropdown-menu__item product-detail__dropdown-menu__item--bold">
                                                     <span class="custom-checkbox custom-checkbox-wrapper">
                                                        <input class="custom-checkbox__input" type="checkbox"
                                                               :id="targetFrequency + outerIndex"
                                                               @change="checkSubCategoriesFrequencies(targetFrequency, $event)"
                                                               v-model="frequenciesFilterValues"
                                                               :value="'targetFrequency_' + targetFrequency.jcrValue"/>
                                                        <span class="custom-checkbox__checkmark"></span>
                                                    </span>
                                            <label class="custom-control-label"
                                                   :for="targetFrequency + outerIndex">{{targetFrequency.displayName}}</label>
                                        </li>
                                        <li v-for="(targetFrequencyFacet, innerIndex) in targetFrequency.targetApplications"
                                            class="product-detail__dropdown-menu__item">

                                                <span class="custom-checkbox custom-checkbox-wrapper">
                                                        <input class="custom-checkbox__input" type="checkbox"
                                                               :id="targetFrequencyFacet.displayName + outerIndex + innerIndex"
                                                               :value="'targetFrequency_' + targetFrequencyFacet.jcrValue"
                                                               v-model="frequenciesFilterValues"
                                                               @change="fetchProductsWithModelFilters"/>
                                                        <span class="custom-checkbox__checkmark"></span>
                                                    </span>
                                            <label class="custom-control-label"
                                                   :for="targetFrequencyFacet.displayName + outerIndex + innerIndex">{{targetFrequencyFacet.displayName}}</label>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <button class="parametric-close-button" @click.prevent="showTargetFrequencies = false"><i
                                    class="fa fa-close"></i></button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="row parametric-table_row">
            <div class="col-md-12">
                <div class="parametric-search">
                    <div class="row">
                        <!-- Parametric search table -->
                        <div class="col-md-12">
                            <div class="ps-controls">
                                <div class="pull-left parametric-button-group">

                                    <button class="btn btn-default" @click="toggleParametersBox()"
                                            id="toggle-parameters">
                                        <div class="svg-icon">
                                            <svg id="button-icon__add-remove" class="button-icon" data-name="Layer 1"
                                                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" x="0px" y="0px"
                                                 style="enable-background:new 0 0 511 173;">
                                                <rect class="cls-1" x="1" y="1" width="12" height="12"/>
                                                <path id="gear-1" class="cls-2"
                                                      d="M13.05,7.81V6.19c-.83-.29-1.35-.37-1.61-1h0c-.26-.63.05-1.07.42-1.85L10.72,2.19c-.78.37-1.22.68-1.85.42h0c-.64-.26-.72-.79-1-1.61H6.24c-.29.82-.37,1.35-1,1.61h0c-.63.26-1.07,0-1.85-.42L2.23,3.33c.38.78.69,1.22.43,1.85h0c-.27.64-.79.72-1.61,1V7.81c.81.29,1.35.37,1.61,1h0c.26.64-.06,1.08-.43,1.85l1.15,1.14c.78-.37,1.21-.68,1.85-.42h0c.64.26.72.79,1,1.61H7.86c.29-.82.37-1.35,1-1.61h0c.63-.26,1.06,0,1.85.42l1.14-1.14c-.37-.78-.68-1.21-.42-1.85S12.23,8.1,13.05,7.81ZM7.05,9a2,2,0,1,1,2-2A2,2,0,0,1,7.05,9Z"/>
                                            </svg>
                                            add/remove parameters
                                        </div>
                                    </button>

                                    <div class="parameters">
                                        <div class="pull-right close-parameters" @click.prevent="toggleOverlay()"><span
                                                class="lnr lnr-cross2" title="Close"></span></div>
                                        <ul>
                                            <li v-for="(key, value) in orderedColumnsByKey">
                                                <a class="active" @click="toggleColumn(value,$event)"><i
                                                        class="lnr lnr-check"></i>
                                                    <span v-html="key">{{key}}</span></a>
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="button-special">
                                        <button id="reset-filters" class="btn btn-default" @click="resetFilters()">
                                            <div class="svg-icon">
                                                <svg id="button-icon__reset" class="button-icon" data-name="Layer 1"
                                                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" x="0px"
                                                     y="0px" style="enable-background:new 0 0 511 173;">
                                                    <rect class="cls-1" x="1" y="1" width="12" height="12"/>
                                                    <path id="refresh-2" class="cls-2"
                                                          d="M7.75,1.75a5.25,5.25,0,0,0-5.24,5H1l2.27,3,2.23-3H4a3.76,3.76,0,1,1,.8,2.57l-.92,1.23a5.25,5.25,0,1,0,3.86-8.8Z"/>
                                                </svg>
                                                reset filters
                                            </div>
                                        </button>
                                    </div>

                                    <div class="button-special">
                                        <a class="btn btn-default" id="save-excel"
                                           @click="downloadParametricExcelWithModelFilters">
                                            <div class="svg-icon">
                                                <svg id="button-icon__save" class="button-icon" data-name="Layer 1"
                                                     xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
                                                    <rect class="cls-1" x="1" y="1" width="12" height="12"/>
                                                    <path id="download-19" class="cls-2"
                                                          d="M7,11.5,3,7H6V1H8V7h3Zm5-.5v1H2V11H1v2H13V11Z"/>
                                                </svg>
                                                save to excel
                                            </div>
                                        </a>
                                    </div>

                                    <!-- Tablet and mobile filter section -->
                                    <div class="row filter-section-tablet btn-toolbar">

                                        <div class="input-group filter-type-number">
                                            <input type="text" class="form-control"
                                                   v-model="filterKey"
                                                   placeholder="Filter by type number"
                                                   aria-label="Filter by type number">
                                        </div>

                                        <div class="two-button-container">
                                            <div class="two-button-flex">
                                                <a class="btn btn-default"
                                                   id="compare-button"
                                                   target="_blank"
                                                   @click="routeToComparePage()">
                                                    <i class="fa fa-exchange"></i> compare
                                                </a>

                                                <a v-on:click="clickFilters()"
                                                   class="btn btn-default"
                                                   id="parametric-filters-button"
                                                   target="_blank">
                                                    <i class="fa fa-filter"></i> parametric filters
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="parametric-search__overview">
                                <!--SEARCH ELEMENT COLLAPSIBLE-->
                                <div class="parametric-search__col parametric-search__col--collapsible"
                                     :class="{'parametric-search__col--collapsed' : !sideFacetIsActive}">
                                    <div class="parametric-filters-wrapper">
                                        <div class="filters-head">
                                            <h4>Parametric filters</h4>
                                            <span class="filters-head__filters-toggle"
                                                  @click="sideFacetIsActive = !sideFacetIsActive">
                                                    <i class="fa fa-filter"></i>
                                                    <i class="fa fa-close"></i>
                                                </span>
                                        </div>

                                        <ul class="filters-list">
                                            <li v-for="facet in validFacets" class="filters-list__item"
                                                :key="facet.name">
                                                <checkbox-facet v-if="facet.values && facetFilterVal[facet.name]"
                                                                @updateCheckbox="updateCheckbox"
                                                                :displayName="facet.displayName === 'Package' ? 'Package outline' : facet.displayName"
                                                                :facetName="facet.name"
                                                                :facetValues="facet.values"
                                                                :model="parametricFilters[facet.name]">
                                                </checkbox-facet>

                                                <range-slider v-else-if="facet.range && facetFilterVal[facet.name]"
                                                              @updateRange="updateRange"
                                                              :displayName="facet.displayName"
                                                              :sliderid="facet.name"
                                                              :values="facet.range"
                                                              :model="parametricFilters">
                                                </range-slider>
                                            </li>
                                            <li v-if="demoBoardFacets && demoBoardFacets.length > 0"
                                                class="filters-list__item demo-board__main-item">
                                                <div>
                                                        <span class="filters-list__item-name demo-board__item-name"
                                                              :class="{'filters-list__item-name--active' : isDemoBoardCollapsed}"
                                                              @click="isDemoBoardCollapsed = !isDemoBoardCollapsed">
                                                            <span>Demo Board</span><i class="fa fa-caret-up"></i>
                                                        </span>
                                                    <ul class="demo-board__list filters-list__nested-list"
                                                        :class="{'filters-list__nested-list--collapsed' : isDemoBoardCollapsed}">
                                                        <li v-for="demoFacet in demoBoardFacets"
                                                            class="filters-list__item" :key="demoFacet.name">
                                                            <checkbox-facet
                                                                    v-if="demoFacet.values && demoFacetFilterVal[demoFacet.name]"
                                                                    @updateCheckbox="updateCheckbox"
                                                                    :displayName="demoFacet.displayName === 'Package' ? 'Package outline' : demoFacet.displayName"
                                                                    :facetName="demoFacet.name"
                                                                    :facetValues="demoFacet.values"
                                                                    :model="parametricFilters[demoFacet.name]">
                                                            </checkbox-facet>

                                                            <range-slider
                                                                    v-else-if="demoFacet.range && demoFacetFilterVal[demoFacet.name]"
                                                                    @updateRange="updateRange"
                                                                    :displayName="demoFacet.displayName"
                                                                    :sliderid="demoFacet.name"
                                                                    :values="demoFacet.range"
                                                                    :model="parametricFilters">
                                                            </range-slider>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- TABLE ELEMENT RESULTS-->
                                <div class="parametric-search__results"
                                     :class="{'parametric-search__results--full-width' : !sideFacetIsActive}">
                                    <div @scroll="backToTop($event), makeTableHeaderSticky($event)"
                                         id="table-paramteric" class="parametric-search__results-content">
                                        <table id="parametric-search__table"
                                               class="parametric-search__col-table table table-striped">
                                            <thead class="table__thead">
                                            <tr>
                                                <th v-for="(key, value, index) in orderedColumnsByKey"
                                                    :data-column="value" class="table__th"
                                                    :class="{'table__element--fixed': index === 0}"
                                                    @click="setSort(value, false, $event)">
                                                    <template v-if="index === 0">
                                                                <span
                                                                        class="table__th-content--left table__th-content--cursor"
                                                                        @click="routeToComparePage()">
                                                                    <i class="fa fa-exchange remove-on-desktop compare-icon"></i>
                                                                    <span class="remove-on-tablet"> Compare</span>
                                                                </span>
                                                        <span class="table__th-content--right">
                                                                    <span class="header">Type number</span>
                                                                    <input class="table__input desktop-only"
                                                                           v-model="filterKey" type="text"
                                                                           placeholder="Filter by type number"/>
                                                                    <span class="table__th-sort-icons">
                                                                        <i class="fa fa-sort-up"></i>
                                                                        <i class="fa fa-sort-down"></i>
                                                                    </span>
                                                                </span>
                                                    </template>
                                                    <template v-else>
                                                      <span v-html="key === 'Package' ? 'Package outline' : key"></span>
                                                      <span class="table__th-sort-icons">
                                                                    <i class="fa fa-sort-up"></i>
                                                                    <i class="fa fa-sort-down"></i>
                                                                </span>

                                                    </template>
                                                </th>
                                            </tr>
                                            </thead>

                                            <tbody class="table__tbody">
                                            <tr v-if="!validResponse" class="table__row table__row-no__products">
                                                <td class="visible table__cell table__element--fixed">No products can be
                                                    displayed.
                                                </td>
                                            </tr>
                                            <tr v-for="(product, parent_index) in productOrderedByKey"
                                                class="table__row">
                                                <td v-for="(key, value, inner_index) in product"
                                                    class="visible table__cell"
                                                    :data-column="value"
                                                    :class="{'table__element--fixed': inner_index === 0}">
                                                    <!--first element-->
                                                    <template v-if="inner_index === 0">
                                                                <span class="custom-checkbox custom-checkbox-wrapper">
                                                                    <input class="custom-checkbox__input"
                                                                           type="checkbox"
                                                                           :disabled="comparableLimitReached(product.col0.value + '_' + product.col94.value)"
                                                                           :value="product.col0.value + '_' + product.col94.value"
                                                                           v-model="productsToCompare"/>
                                                                    <span class="custom-checkbox__checkmark"></span>
                                                                </span>
                                                        <span class="table__cell-meta-info">
                                                                    <a :href="key.url"
                                                                       class="table__cell-anchor">{{key.value}}</a>
                                                                    <span>{{key.description}}</span>

                                                                    <span class="table__cell-cta-wrapper">
                                                                        <a v-if="key.datasheet"
                                                                           class="table__cell-cta-download"
                                                                           :href="key.datasheet">
                                                                            <span class="icon icon__download"></span>
                                                                        </a>
                                                                        <a v-if="key.order" class="table__cell-cta-cart"
                                                                           :href="key.url + '#ordering'">
                                                                            <span
                                                                                    class="icon icon__shopping-cart"></span>
                                                                        </a>
                                                                    </span>
                                                                    <div v-if="key.recommendedDriver != null">
                                                                        <a class="driver__link--cursor__pointer"
                                                                           @click="routeToRecommendedDriverPage(product.col0.value + '_' + key.recommendedDriver)">Recommended line-up</a>
                                                                     </div>
                                                                </span>
                                                    </template>

                                                    <template v-else-if="key.url != null && inner_index > 0">
                                                        <a :href="key.url"><b>{{key.value}}</b></a>
                                                    </template>

                                                    <template
                                                            v-else-if="key.url == null && inner_index > 0 && value !== 'col92'">
                                                        {{key.value}}
                                                    </template>
                                                    <template
                                                            v-else-if="key.url == null && inner_index > 0 && value === 'col92' && product.col92.value != null && isAuthenticated">
                                                        <a class="driver__link--cursor__pointer"
                                                           @click="routeToDemoBoardPage(product.col0.value)"><b>View</b></a>
                                                    </template>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <button id="back-to-top" type="button"
                                            class="btn btn-primary btn-circle btn-lg back-to-top"
                                            @click="topFunction()">
                                        <i class="fa fa-arrow-up"></i>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div v-else-if="!isParametricSearchLoading && !isSuccess">
        <h4>The parametric table can't be loaded at the moment.</h4>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {DOWNLOAD_PRODUCTS_EXCEL, FETCH_PRODUCTS, RESET_PRODUCTS} from "@/store/actions.type";
import RangeSlider from "../RangeSlider";
import CheckboxFacet from "../CheckboxFacet";
import _ from 'lodash';

export default {
    name: "ParametricSearch",
    components: {
        'range-slider': RangeSlider,
        'checkbox-facet': CheckboxFacet,
    },
    data() {
        return {
            sortKey: null,
            sortOrder: null,
            filterKey: '',
            queryParams: [],
            facetFilterValues: [],
            frequenciesFilterValues: [],
            productsToCompare: [],
            typeNumberQueryParams: {
                typeNumber: [],
            },
            currentUrl: '',
            targetApplicationIsActive: false,
            sideFacetIsActive: false,
            parametricFilters: {},
            showTargetApplications: false,
            showTargetFrequencies: false,
            isDemoBoardCollapsed: true
        }
    },
    props: {
        isPublic: {
            type: Boolean
        }
    },
    computed: {
        ...mapGetters("parametricSearch", ["isParametricSearchLoading", "products", "columns", "facets", "demoBoardFacets", "isSuccess", "validResponse", "targetApplications", "targetFrequencies"]),
        ...mapGetters(["isAuthenticated"]),

        orderedColumnsByKey: function () {
            return this.orderByDefaultKey(this.columns);
        },

        productOrderedByKey: function () {
            let structuredCols = [];
            //sortKey is the column number
            let orderedArray = this.orderByCustomKey(this.products, this.sortKey, this.sortOrder);

            let filteredArray = this.filterByCustomKey(orderedArray, this.filterKey);

            for (let i = 0; i < filteredArray.length; i++) {
                structuredCols.push(this.orderByDefaultKey(filteredArray[i]))
            }
            return structuredCols;
        },

        columnNumber: function () {
            return Object.keys(this.products).length;
        },

        contactRedirectPath: function () {
            return contactPageLink;
        },

        productCategory: function () {
            if (typeof pcat !== "undefined") {
                return pcat;
            } else {
                return null;
            }
        },

        applicationCategory: function () {
            if (typeof acat !== "undefined") {
                return acat;
            } else {
                return null;
            }
        },

        validFacets: function () {
            //return only non-null facets
            return this.facets.filter(function (item) {
                return item !== null;
            });
        },

        typeNumberParams: function () {
            if (this.productsToCompare.length === 0) {
                return;
            }

            this.typeNumberQueryParams.typeNumber = this.productsToCompare;

            return this.typeNumberQueryParams;
        },

        facetFilterVal: function () {

            for (const key in this.facets) {
                const facet = this.facets[key];
                if (facet) {
                    const facetName = facet.name;
                    if (!this.parametricFilters[facetName]) {
                        this.parametricFilters[facetName] = {};
                    }
                }
            }
            return this.parametricFilters;
        },

        demoFacetFilterVal: function () {

            for (const key in this.demoBoardFacets) {
                const facet = this.demoBoardFacets[key];
                if (facet) {
                    const facetName = facet.name;
                    if (!this.parametricFilters[facetName]) {
                        this.parametricFilters[facetName] = {};
                    }
                }
            }
            return this.parametricFilters;
        },

    },
    mounted() {
        this.currentUrl = window.location.href;
        if (this.isPublic && this.productCategory != null) {
            this.fetchProducts({cat: this.productCategory});
        } else if (this.isPublic && this.applicationCategory != null) {
            this.fetchProducts({targetApplication: this.applicationCategory});
        } else {
            this.resetProducts();
        }
    },
    methods: {
        commit(mutation, payload) {
            return this.$store.commit('parametricSearch/' + mutation, payload);
        },
        dispatch(action, payload) {
            return this.$store.dispatch('parametricSearch/' + action, payload);
        },
        fetchProducts(queryParameters) {
            this.dispatch(FETCH_PRODUCTS, queryParameters);
        },
        //invokes loading products eagerly.
        resetProducts() {
            this.dispatch(RESET_PRODUCTS, null);
        },
        backToTop($event) {

            let tableContent = $event.target;
            let myButton = document.getElementById("back-to-top");

            if (tableContent.scrollTop > 30) {
                myButton.style.display = "block";
            } else {
                myButton.style.display = "none";
            }
        },
        topFunction() {
            let tableContent = document.querySelector("#table-paramteric");
            tableContent.scrollTop = 0;
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },

        makeTableHeaderSticky($event) {
            document.querySelector('.parametric-search .table__tbody').style.paddingTop = '75px';
            document.querySelector('.table__thead > tr').style.position = 'absolute';
            document.querySelector('.table__thead > tr').style.top = $event.srcElement.scrollTop + 'px';
        },
        downloadParametricExcelWithModelFilters() {
            this.dispatch(DOWNLOAD_PRODUCTS_EXCEL, this.createParametricQueryParams());
            return false;
        },
        fetchProductsWithModelFilters() {
            const query = this.createParametricQueryParams();
            this.fetchProducts(query);
        },
        createParametricQueryParams() {

            if (this.isPublic) {
                if (this.productCategory != null) {
                    this.queryParams = new URLSearchParams({cat: this.productCategory});

                } else if (this.applicationCategory != null) {
                    this.queryParams = new URLSearchParams({targetApplication: this.applicationCategory});
                }
            } else {
                this.queryParams = new URLSearchParams();
            }

            for (const queryKey in this.parametricFilters) {
                //range value in value1:value2 format, comes from RangeSlider component
                if (typeof this.parametricFilters[queryKey] === 'string' && this.parametricFilters[queryKey].length > 0) {
                    this.queryParams.append(queryKey, this.parametricFilters[queryKey])
                } else if (typeof this.parametricFilters[queryKey] === 'object' && Object.keys(this.parametricFilters[queryKey]).length > 0) {
                    // checkboxLabel:checked (checked is a boolean) format from the checkboxFacet component.
                    for (const checkboxLabel in this.parametricFilters[queryKey]) {
                        if (this.parametricFilters[queryKey][checkboxLabel]) {
                            this.queryParams.append(queryKey, checkboxLabel);
                        }
                    }
                }
            }

            //append the target application values
            for (let i = 0; i < this.facetFilterValues.length; i++) {
                this.queryParams.append(this.facetFilterValues[i].split('_')[0], this.facetFilterValues[i].split('_')[1]);
            }

            //append the target frequencies values
            for (let i = 0; i < this.frequenciesFilterValues.length; i++) {
                this.queryParams.append('cat', this.frequenciesFilterValues[i].split('_')[1]);
            }

            return this.queryParams;
        },
        clickFilters() {
            document.getElementsByClassName("parametric-search__col--collapsible")[0].classList.add("show-col-collapsible");
        },
        hideColumn() {
            document.getElementsByClassName("parametric-search__col--collapsible")[0].classList.remove("show-col-collapsible");
        },
        orderByDefaultKey: function (products) {
            let results = [];
            for (let key in products) {
                results.push(key);
            }
            results.sort();

            let structuredCols = {};

            for (let i = 0, len = results.length; i < len; i++) {
                structuredCols[results[i]] = products[results[i]];
            }

            return structuredCols;
        },

        /**
         * Orders array by key
         * @param object Products
         * @param key sortKey is the column number
         * @param order 'asc/desc'
         * @returns {[]|*}
         */
        orderByCustomKey: function (products, key, order = 'asc') {

            if (!key) {
                return products;
            }

            let orderedArray = [];
            let productsArray = Object.values(products);

            for (let i = 0; i < productsArray.length; i++) {
                let value;
                // deconstruct product into array productRow [{key, value}, ...]
                let productRow = Object.entries(productsArray[i]).map(([key, value]) => ({key, value}));

                for (let j = 0; j < productRow.length; j++) {
                    if (productRow[j].key === key) {
                        value = productRow[j].value.value;
                    }
                }
                orderedArray.push({"index": (Object.keys(products)[i]), "value": value});
            }

            //order column values
            orderedArray = _.orderBy(orderedArray, ['value'], [order]);

            let finalOrder = [];

            //rebuild from the original array in the correct order
            for (let k = 0; k < orderedArray.length; k++) {
                finalOrder.push(this.products[orderedArray[k].index]);
            }

            orderedArray = finalOrder;
            return orderedArray;
        },
        filterByCustomKey: function (products, key) {
            if (!key) {
                return products;
            }

            let filteredArray = [];
            filteredArray = _.filter(products, function (item) {
                return (item.col0.value.toLowerCase().indexOf(key.toLowerCase()) !== -1
                        || item.col0.description.toLowerCase().indexOf(key.toLowerCase()) !== -1);
            });

            return filteredArray;
        },

        toggleOverlay: function () {
            $('.parametric-search .filter-column').removeClass('active');

            if ($('.parametric-search .parameters').hasClass('active')) {
                $('.parametric-search .parameters').removeClass('active');
            }
            $('.parametric-search .overlay').toggleClass('active');
        },

        toggleParametersBox: function () {
            this.toggleOverlay();
            $('.parametric-search .parameters').toggleClass('active');
        },

        toggleColumn: function (column, $event) {
            let el = $event.target;
            $(el).closest('li a').toggleClass('active');
            $('.parametric-search #parametric-search__table').find('th[data-column=' + column + '], td[data-column=' + column + ']').toggleClass('disabled');

        },
        setSort: function (type, reverse, $event) {
            if ($event.target.tagName.toLowerCase() === 'input'
                    || $event.target.innerText === 'Compare') {
                return;
            }
            this.sortKey = type;
            this.sortOrder = (this.sortOrder === 'asc') ? 'desc' : 'asc';

            // reset all filters
            $('th i').removeClass('inactive');

            let icons = $event.target;
            if (this.sortOrder === 'asc') {
                $(icons).closest('th').find('.fa-sort-down').addClass('inactive');
            } else {
                $(icons).closest('th').find('.fa-sort-up').addClass('inactive');
            }
        },
        redirectToPredefined: function (topicName) {
            if (this.isAuthenticated) {
                if (this.isPublic) {
                    window.location.href = "/my-ampleon.html#/my-support?topic=" + topicName;
                } else {
                    this.$router.push({name: 'my-support', query: {topic: topicName}});
                }
            } else {
                if(topicName == "SUPPORT") {
                  window.location.href = "/support";
                } else {
                  window.location.href = this.contactRedirectPath + "?topic=" + topicName;
                }
            }
        },

        updateRange: function (emittedSliderValue) {
            this.fetchProductsWithModelFilters();
        },

        updateCheckbox: function (emittedCheckboxValue) {
            this.fetchProductsWithModelFilters();
        },

        checkSubCategories: function (mainTargetApplicationFacet, $event) {
            if ($event.target.checked) {
                for (let i = 0; i < mainTargetApplicationFacet.targetApplications.length; i++) {
                    this.facetFilterValues.push('targetApplication_' + mainTargetApplicationFacet.targetApplications[i].jcrValue);
                }
            } else {
                for (let i = 0; i < this.facetFilterValues.length; i++) {
                    let searchElement = 'targetApplication_' + mainTargetApplicationFacet.jcrValue;
                    if (this.facetFilterValues.indexOf(searchElement) >= 0) {
                        this.facetFilterValues.splice(this.facetFilterValues
                                .indexOf(searchElement), 1);
                    }
                    for (let j = 0; j < mainTargetApplicationFacet.targetApplications.length; j++) {
                        let searchElementTargetApp = 'targetApplication_' + mainTargetApplicationFacet.targetApplications[j].jcrValue;
                        if (this.facetFilterValues.indexOf(searchElementTargetApp) >= 0) {
                            this.facetFilterValues.splice(this.facetFilterValues
                                    .indexOf(searchElementTargetApp), 1);
                        }
                    }
                }
            }
            this.fetchProductsWithModelFilters();
        },
        checkSubCategoriesFrequencies: function (mainTargetFrequencyFacet, $event) {
            if ($event.target.checked) {
                for (let i = 0; i < mainTargetFrequencyFacet.targetApplications.length; i++) {
                    this.frequenciesFilterValues.push('targetFrequency_' + mainTargetFrequencyFacet.targetApplications[i].jcrValue);
                }
            } else {
                for (let i = 0; i < this.frequenciesFilterValues.length; i++) {
                    const targetFrequencyValue = 'targetFrequency_' + mainTargetFrequencyFacet.jcrValue;
                    if (this.frequenciesFilterValues.indexOf(targetFrequencyValue) >= 0) {
                        this.frequenciesFilterValues.splice(this.frequenciesFilterValues
                                .indexOf((targetFrequencyValue)), 1);
                    }
                    for (let j = 0; j < mainTargetFrequencyFacet.targetApplications.length; j++) {
                        const targetFrequencyApplicationValue = 'targetFrequency_' + mainTargetFrequencyFacet.targetApplications[j].jcrValue;
                        if (this.frequenciesFilterValues.indexOf(targetFrequencyApplicationValue) >= 0) {
                            this.frequenciesFilterValues.splice(this.frequenciesFilterValues
                                    .indexOf((targetFrequencyApplicationValue)), 1);
                        }
                    }
                }
            }
            this.fetchProductsWithModelFilters();
        },

        resetFilters: function () {
            this.sortKey = null;
            this.sortOrder = null;
            this.filterKey = '';
            this.queryParams = [];
            this.facetFilterValues = [];
            this.frequenciesFilterValues = [];
            this.parametricFilters = {};

            // show all the table columns
            $('th i').removeClass('inactive');
            $('.parametric-search #parametric-search__table').find('th, td').show();
            $('.parameters ul li a').addClass('active');

            if (this.isPublic) {
                this.fetchProductsWithModelFilters();
            } else {
                this.resetProducts();
            }
        },

        comparableLimitReached: function (value) {
            return this.productsToCompare.length > 4 && this.productsToCompare.indexOf(value) === -1;
        },

        routeToComparePage: function () {
            if (this.productsToCompare.length < 2) {
                return false;
            } else {
                this.$router.push({
                    path: this.isPublic ? '/compare' : '/my-parametric-search/compare',
                    query: this.typeNumberParams
                });
            }
        },

        routeToRecommendedDriverPage: function (typeNumberValue) {
            let recommendedURLParam = {
                typeNumber: [typeNumberValue],
            };
            this.$router.push({
                path: this.isPublic ? '/recommended-driver' : '/my-parametric-search/recommended-driver',
                query: recommendedURLParam
            });
        },

        routeToDemoBoardPage: function (typeNumberValue) {
            let recommendedURLParam = {
                typeNumber: typeNumberValue,
            };
            this.$router.push({
                path: this.isPublic ? '/demo-board' : '/my-parametric-search/demo-board',
                query: recommendedURLParam
            });
        },
    },
};
</script>
